import { logger } from '@gem/modules/logger';

import { IUserDeviceKeyPackage } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

import { getCommitMessages } from './getCommitMessages';
import { getKeyPackages } from './getKeyPackages';

export const addMembersToSecretGroup = async (
  groupId: string,
  membersIds: string[]
): Promise<{ error: string | null }> => {
  try {
    const mlsGroup = MlsStorageService.loadGroup(groupId);

    if (!mlsGroup) {
      throw new Error('MlsGroup does not exist');
    }

    const commitBuilderWithRemovedMembers = MlsStorageService.findMemberIdsInGroupAndRemove(
      membersIds,
      mlsGroup
    );

    let keyPackages: IUserDeviceKeyPackage[] = [];
    if (membersIds) {
      const keyPackagesResponse = await getKeyPackages(membersIds);
      keyPackages = keyPackagesResponse.keyPackages.filter((item) =>
        membersIds.includes(item.userId)
      );
    }

    if (!keyPackages.length) {
      return { error: null };
    }

    const addMembersResult = MlsStorageService.addMembersToGroup(
      keyPackages,
      mlsGroup,
      commitBuilderWithRemovedMembers || undefined
    );

    const response = await e2eeModel.addSecretGroupParticipants({
      participantsWelcomeMessages: addMembersResult.welcomeMessages,
      commit: addMembersResult.commit,
      epoch: addMembersResult.epoch,
      groupId,
    });

    if (response.needToSyncCommits) {
      await getCommitMessages(groupId, Number(mlsGroup.currentEpoch()));
      await addMembersToSecretGroup(groupId, membersIds);
    } else {
      MlsStorageService.processMyWelcomeCommit(addMembersResult.welcomeCommit, mlsGroup);
    }

    return { error: null };
  } catch (error) {
    logger.get('Tasks').error('e2ee.addMembersToSecretGroup', error);
    return { error: error.message };
  }
};
